<div mat-dialog-title>
  {{ 'MM.fault.createFault' | translate }}
  <button mat-icon-button type="button" style="float: right;" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div>
    {{ 'MM.fault.createFaultFromCameraText' | translate }}
  </div>
  <div class="form-group">
    <div [hidden]="!isWebcamActive">
    <button mat-button type="button" (click)="startWebcam()" *ngIf="noAccessToWebcam">
      <mat-icon>flip_camera_ios</mat-icon>
      {{ 'MM.button.resetWebcam' | translate }}
    </button>
    <button mat-button type="button" (click)="takePhoto()" *ngIf="!noAccessToWebcam">
      <mat-icon>add_a_photo</mat-icon>
      {{ 'MM.button.takePhoto' | translate }}
    </button>
    <div style="position: relative;" >
      <mydocma-loader *ngIf="isLoading" class="webcam-overlay"></mydocma-loader>
      <div *ngIf="noAccessToWebcam" class="webcam-overlay text-danger">
        <mat-icon>no_photography</mat-icon>
        <div>{{ 'MM.fault.noAccessToWebcam' | translate }}</div>
      </div>
      <video #webcam class="webcam-video" width="100%">
      </video>
    </div>
  </div>
  <div [hidden]="!isSnapshotActive">
    <button mat-button type="button" (click)="isSnapshotActive = false; isWebcamActive = true; attachment = null " >
      <mat-icon>photo_camera</mat-icon>
      Neues Foto
    </button>
    <canvas #snapshot class="snapshot-canvas" ></canvas>
  </div>


  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">
    {{'MM.general.button.cancel' | translate}}
  </button>
  <button mat-button cdkFocusInitial color="accent" type="button" [disabled]="!attachment" (click)="next()">
    {{'MM.general.button.next' | translate}}
  </button>
</div>
